export default "__VITE_ASSET__DB1OYf17__"